/**
 * Single module-level counter shared by both FormField render paths
 * (FormFieldTailwind and FormFieldStyled). A page with mixed routing draws
 * sequential ids from this one counter, so auto-generated ids never collide
 * across the two paths. Preserves the pre-split `FormField-N` id format.
 */

let idCounter = 0;

export function nextFormFieldId(): string {
  return `FormField-${idCounter++}`;
}
